import { curiousBlue } from './color'

export const focusedStyle = {
  boxShadow: `0 0 0.25rem ${curiousBlue}`,
}
